import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as InfoIcon } from "../../../../../../assets/fi-rr-info.svg";
import CustomDate from "../../../../../../components/customDate/CustomDate";
import CustomSelect from "../../../../../../components/customSelect/CustomSelect";
import CustomFile from "../../../../../../components/customFile/CustomFile";
import CustomInput from "../../../../../../components/customInput/CustomInput";
import CustomButton from "../../../../../../components/CustomButton";
import { Checkbox, Group, Modal, Radio, Tooltip, Stack, Anchor, Button } from "@mantine/core";
import { useForm, useFormContext } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, } from "reactstrap";
import { Controller } from "react-hook-form";
import AgreementModal from "../../../../../fileClaim/AgreementModal";
import DocuSignModal from "../../../../../fileClaim/DocuSignModal";
import PowerContent from "../../../../../fileClaim/PowerContent";
import { ReactComponent as FlyClaimIcon } from "../../../../../../assets/header button.svg";
import { ReactComponent as Avatar } from "../../../../../../assets/Avatar.svg";
import { ReactComponent as DocumentIcon } from "../../../../../../assets/Document.svg";
import ViewFileModal from "../../../../../../components/Modals/ViewFileModal.js";
import attachmenturl from "../../../../../../api/attachmenturl";
import Swal from "sweetalert2";
import base_url from "../../../../../../api/bootapi.js";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as Close } from "../../../../../../assets/modalCloseIcon.svg";
import RHFTextarea from "../../../../../../components/form/RHFTextarea.jsx";
import { IconEye } from "@tabler/icons-react";
import { base64ToBlob } from "../../../../../../components/utils/flightApiUtils.js";
import UnifiedAgreementModal from "./UnifiedAgreementModal.jsx";
import WesignModal from "./WesignModal.jsx";
import PowerOfAttorneyContent from "./PowerOfAttorneyContent.jsx";
import AgreementContent from "./AgreementContent.jsx";


const Attorneynotes = ({
  setLoading,
  setActive,
  setTemporaryOpened

}) => {












  const { watch, setValue, control, getValues, formState: { errors } } = useFormContext();

  const [isAgreementModalOpen, setIsAgreementModalOpen] = useState(false);
  const [isDocusignModalOpen, setIsDocusignModalOpen] = useState(false);


  const is_term_watched = watch('is_terms_watched')
  const signUrl = watch('signUrl');

  const formValues = getValues();


  const travelers = watch('travelers');
  const originalFlightDetails = watch('original_flight_details');
  const actualFlightDetails = watch('actual_flight_details');

  const signers = watch('signers');

  const envelopeId = watch("envelopeId"); // Watch the envelope ID
  const signedAgreement = watch("agreement"); // Watch if we have the file
  const generatedPOA = watch("power_of_attorney"); // Watch if we have the file

  const agreementContentRef = useRef(null);
  const powerOfAttoreyRef = useRef(null);



  const getPowerOfAttorney = async () => {
    let poaPdfBlob = null;
    let signerList = [];
    const content = powerOfAttoreyRef.current;
    let htmlString = null;

    if (content) {
      htmlString = content.innerHTML;
    }
    setLoading(true);

    // 1. Get values directly from React Hook Form
    const formValues = getValues();

    // 2. Map the signers from the RHF 'travelers' array
    const activeTravelers = formValues?.travelers?.filter(t => t.first_name || t.last_name) || [];

    const signers = activeTravelers.map((traveler, index) => ({
      name: `${traveler.name_prefix ? `${traveler.name_prefix.toUpperCase()} ` : ""}${(traveler.first_name || "").toUpperCase()} ${(traveler.last_name || "").toUpperCase()}`.trim(),
      email_id: `flyandclaim${index}@gmail.com`, // Update this if you ever add actual emails for travelers in RHF
    }));

    try {
      const response = await axios.post(
        `${base_url.api1}/tourapp/power_of_attorney_latest`,
        {
          html_string: htmlString,
          signers: signers,
        }
      );

      console.log(response);
      if (response.data && response.data.status && response.data.document) {
        signerList = response.data.signers || [];
        const base64PDF = response.data.document;
        const poaPdfBlobTemp = await base64ToBlob(base64PDF, "application/pdf");

        if (poaPdfBlobTemp) {
          poaPdfBlob = new File([poaPdfBlobTemp], "power_of_attorney.pdf", {
            type: "application/pdf",
          });
        }
        setLoading(false);
      } else {
        poaPdfBlob = null;
        signerList = [];
        console.error("Failed to fetch Power of Attorney PDF.");
        setLoading(false);
      }
    } catch (error) {

      setLoading(false);
      poaPdfBlob = null;
      signerList = [];
    } finally {
      setLoading(false);
    }

    return { poaPdfBlob, signerList };
  };


  const [signerWesignUrl, setSignerWesignUrl] = useState(null);
  const [signersEnvelopeId, setSignerEnvelopeId] = useState(null);
  const [signerEmail, setSignerEmail] = useState(null);
  const [isSignerModalOpen, setIsSignerModalOpen] = useState(null);


  const fetchSignedDocument = async () => {

    if (!envelopeId) return; // Prevent fetching if no ID exists



    try {

      setLoading(true); // Shows Mantine loader on the parent screen



      const sign_url = `${base_url.api1}/tourapp/wesign_signed_doc_new?id=${envelopeId}`;

      const response = await axios.get(sign_url);



      if (response.data?.Document) {

        const document_url = response.data.Document;

        const pdfResponse = await fetch(document_url);



        if (!pdfResponse.ok) {

          throw new Error("Failed to fetch the document.");

        }



        const pdfBlob = await pdfResponse.blob();



        // Convert Blob to a File object (highly recommended for easy form submission later)

        const pdfFile = new File([pdfBlob], "signed_agreement.pdf", { type: "application/pdf" });



        // Save directly into React Hook Form

        setValue("agreement", pdfFile);

        console.log("Document successfully fetched and saved to form!");



      } else {

        console.error("Signed document is not present in the response.");

      }

    } catch (error) {

      console.error("Error fetching signed document:", error);

    } finally {

      setLoading(false); // Hide loader

    }

  };


  // Make sure to destructure getValues and setValue from your useForm() hook
  // const { getValues, setValue, watch } = useForm({ ... });

  const fetchSignerSignedDocument = async () => {
    // 1. Extract envelope ID and signers directly from React Hook Form state

    const currentSigners = getValues("signers") || [];

    if (!signersEnvelopeId) {
      console.warn("Cannot fetch document: No envelope ID found in form.");
      return;
    }

    try {
      setLoading(true);

      const sign_url = `${base_url.api1}/tourapp/wesign_signed_doc_new?id=${signersEnvelopeId}&email=${signerEmail}`;
      const response = await axios.get(sign_url);

      // 2. Update the specific signer's status inside React Hook Form
      if (response?.data && response?.data?.status_code === 200) {
        const updatedSigners = currentSigners.map((signer) => {
          if (signer.recipient === signerEmail) {
            return { ...signer, signed: true };
          }
          return signer;
        });

        // Update the signers array in RHF so the UI updates
        setValue("signers", updatedSigners, { shouldValidate: true, shouldDirty: true });
      }

      // 3. Fetch the PDF and save it as a File object in React Hook Form
      if (response.data?.Document) {
        const document_url = response.data.Document;
        const pdfResponse = await fetch(document_url);

        if (!pdfResponse.ok) {
          throw new Error("Failed to fetch the document.");
        }

        const pdfBlob = await pdfResponse.blob();
        const pdfFile = new File([pdfBlob], "power_of_attorney.pdf", { type: "application/pdf" });

        // Save the generated file directly into the RHF "agreement" field
        setValue("power_of_attorney", pdfFile, { shouldValidate: true, shouldDirty: true });
        console.log("Document successfully fetched and saved to form!");

      } else {
        console.error("Signed document is not present in the response.");
      }
    } catch (error) {
      console.error("Error fetching signed document:", error);
    } finally {
      setLoading(false);
    }
  };


  const getSignerName = (signer) => {
    let name = "";

    if (signer) {
      if (typeof signer !== "string") return "";
      name = signer.charAt(0).toUpperCase() + signer.slice(1).toLowerCase();
      if (name.length > 22) {
        name = name.slice(0, 22) + "...";
      }

      return name;
    } else {
      return "";
    }
  };





  const handleCopyLink = (signer) => {
    const link = signer.signing_url;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Link Copied",
          text: `The signing link has been copied to your clipboard.`,
        });
      })
      .catch((error) => {
        console.error("Failed to copy link:", error);
        Swal.fire({
          icon: "error",
          title: "Copy Failed",
          text: `Failed to copy the signing link.`,
        });
      });
  };

  const handleSignerClick = (signer) => {


    setSignerEmail(signer.recipient);
    setSignerEnvelopeId(signer.envelope_id);
    setSignerWesignUrl(signer.signing_url);
    setIsSignerModalOpen(true);

  };


  return (
    <div className="stepper-container">


      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Attorney notes & submission
        </h3>
      </div>


      <div>
        <h4 className="stepper-sub-header" style={{ margin: "20px 0 5px" }}>
          Explain your claim in detail (for attorneys) (optional)
        </h4>
      </div>








      <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
        <div className="file-a-claim">

          <RHFTextarea
            name={`note`}

            minRows={10}
          />

          <Stack mt="md" gap="sm">

            {/* Terms and Conditions */}
            <Controller
              name="is_terms_checked"
              control={control}
              rules={{ required: "Please check terms" }}

              defaultValue={false}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  checked={field.value}
                  onChange={(e) => {
                    if (!is_term_watched) {
                      // Prevent the checkbox from checking if they haven't clicked the link
                      e.preventDefault();

                      Swal.fire({
                        title: "Please read the Terms and Conditions",
                        text: "You must click on the Terms and Conditions link and read them before checking the checkbox.",
                        icon: "warning",
                        confirmButtonText: "OK",
                      });
                    } else {
                      // Pass the event to React Hook Form so it updates the value
                      field.onChange(e);
                    }
                  }}
                  label={
                    <>
                      I agree to the{" "}
                      <Anchor
                        href="https://api.linsoatours.com/Images/other_document/FLT_Airline_claims_-_TC_1.pdf"
                        target="_blank"
                        onClick={() => setValue('is_terms_watched', true)}
                      >
                        Terms and Conditions
                      </Anchor>
                    </>
                  }
                />
              )}
            />

            {/* Agreement */}
            <Group gap="sm">
              <Controller
                name="is_agreement_checked"
                rules={{ required: "Please check agreement" }}
                control={control}
                defaultValue={false}
                render={({ field }) => (
                  <Checkbox
                    {...field}
                    checked={field.value}
                    onChange={(e) => {
                      if (!signedAgreement) {
                        // Prevent the checkbox from checking if they haven't clicked the link
                        e.preventDefault();

                        Swal.fire({
                          title: "Please read the Agreement",
                          text: "You must click on the Agreement link and read them before checking the checkbox.",
                          icon: "warning",
                          confirmButtonText: "OK",
                        });
                      } else {
                        // Pass the event to React Hook Form so it updates the value
                        field.onChange(e);
                      }
                    }}
                    label={
                      <>
                        I agree to the{" "}
                        <Anchor
                          component="button" // Renders an accessible button that looks like a link
                          type="button"
                          onClick={() => {
                            setIsAgreementModalOpen(true);
                          }}
                        >
                          Agreement
                        </Anchor>
                      </>
                    }
                  />
                )}
              />

              {signedAgreement && (
                <Button
                  // variant="subtle"
                  radius={'xl'}
                  size="sm"
                  onClick={() => {
                    if (signedAgreement) {
                      const url = URL.createObjectURL(signedAgreement);
                      window.open(url, "_blank");
                    }
                  }}
                  leftSection={
                    <IconEye size={20} />
                  }
                >
                  View Agreement
                </Button>
              )}
            </Group>

            {/* Power of Attorney */}
            {travelers?.length > 0 && (
              <Group gap="sm" wrap="wrap">
                <Controller
                  name="is_poa_checked"
                  control={control}
                  rules={{ required: "Please check power of attorney" }}
                  defaultValue={false}
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value}
                      onChange={(e) => {
                        if (!generatedPOA) {
                          // Prevent the checkbox from checking if they haven't clicked the link
                          e.preventDefault();

                          Swal.fire({
                            title: "Please read the Power of Attorney",
                            text: "You must click on the Power of Attorney link and read it before proceeding.",
                            icon: "warning",
                            confirmButtonText: "OK",
                          });
                        } else {
                          // Pass the event to React Hook Form so it updates the value
                          field.onChange(e);
                        }
                      }}
                      label={
                        <>
                          I agree to the{" "}
                          <Anchor
                            component="button"
                            type="button"
                            onClick={() => {

                              Swal.fire({
                                title: "Important: Power of Attorney",
                                html: `
      Please print and have all signatures completed. Email back document to <a href="mailto:claims@flyandclaim.com">claims@flyandclaim.com</a>  or access your claim from our website to sign the documents electronically.
      
      `,
                                icon: "warning",
                                confirmButtonText: "OK",
                              }).then(async () => {

                                const { poaPdfBlob, signerList } = await getPowerOfAttorney();
                                setValue('power_of_attorney', poaPdfBlob);
                                setValue('signers', signerList);

                              });

                            }}
                          >
                            Power of Attorney
                          </Anchor>
                        </>
                      }
                    />
                  )}
                />

                {generatedPOA && (
                  <Button
                    radius={'xl'}

                    size="sm"
                    onClick={() => {
                      if (generatedPOA) {
                        const url = URL.createObjectURL(generatedPOA);
                        window.open(url, "_blank");
                      }
                    }}
                    leftSection={
                      <IconEye size={20} />
                    }
                  >
                    View POA
                  </Button>
                )}

                {signers &&
                  signers.length > 0 &&
                  signers.map((signer, index) => (
                    <div className="signer-box" key={index} style={{ width: "fit-content", gap: "15px", borderColor: "#e4e4e4" }}>
                      <div className="signer-details">
                        <span className="signer-icon">
                          {signer?.name.slice(0, 1).toUpperCase()}
                        </span>
                        <span className="signer-name">
                          {getSignerName(signer?.name)}
                        </span>
                      </div>

                      <div className="signer-status">
                        {signer?.signed ? (
                          <span className="signed-success">Signed</span>
                        ) : (
                          <>

                            <Tooltip label='Copy Link'>

                              <span
                                className="sign-btn"
                                onClick={() => handleCopyLink(signer)}
                              >
                                <svg
                                  width="20px"
                                  height="20px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      d="M3 16V4C3 2.89543 3.89543 2 5 2H15M9 22H18C19.1046 22 20 21.1046 20 20V8C20 6.89543 19.1046 6 18 6H9C7.89543 6 7 6.89543 7 8V20C7 21.1046 7.89543 22 9 22Z"
                                      stroke="#314064"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>{" "}
                                  </g>
                                </svg>
                              </span>
                            </Tooltip>
                            <Tooltip label='Sign'>


                              <span
                                className="sign-btn"
                                onClick={() => handleSignerClick(signer)}
                              >
                                <svg
                                  fill="#314064"
                                  width="20px"
                                  height="20px"
                                  viewBox="0 0 56 56"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                  </g>
                                </svg>
                              </span>
                            </Tooltip>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
              </Group>
            )}

            {
              (errors?.is_terms_checked || errors?.is_poa_checked || errors?.is_agreement_checked) && <p style={{ color: 'red' }}>Please check all </p>
            }

          </Stack>
        </div>

        <div className="stepper-btn-wrapper">
          <button className="secondary-btn new-back-btn" type="button" onClick={() => setActive(c => c - 1)} >
            Back
          </button>

          <div className="add-btn-wrapper" >

            <button className="secondary-btn" type="button" onClick={() => setTemporaryOpened(true)}>
              Temporary Save
            </button>

            <button className="primary-btn" type="submit">
              Submit
            </button>




          </div>
        </div>
      </div>


      <UnifiedAgreementModal
        isOpen={isAgreementModalOpen}
        onRequestClose={() => setIsAgreementModalOpen(false)}
        claimData={formValues} // Passes all the form data (name, flights, etc.)
        setValue={setValue} // Passes RHF's setValue to store DocuSign URLs
        setIsDocusignModalOpen={setIsDocusignModalOpen} // Triggers your next step
      />

      <AgreementContent
        formValues={formValues}
        ref={agreementContentRef}
      />


      <PowerOfAttorneyContent
        ref={powerOfAttoreyRef}
        formValues={formValues}
      />

      <WesignModal
        isOpen={isDocusignModalOpen}
        onRequestClose={() => setIsDocusignModalOpen(false)}
        signUrl={signUrl} // Grabbed directly from React Hook Form's state!
        handleIframeClose={() => {
          fetchSignedDocument()
        }}
      />

      <WesignModal
        isOpen={isSignerModalOpen}
        onRequestClose={() => setIsSignerModalOpen(false)}
        signUrl={signerWesignUrl}
        handleIframeClose={fetchSignerSignedDocument}
      />

    </div>
  );
};

export default Attorneynotes;
